<template>
    <div class="root-wrap">
        <div class="header-wrap">
            <div class="user_info-wrap fx-middle">
                <van-cell v-if="hasGetMemberInfo" center style="background-color: transparent">
                    <template #icon>
                        <!-- memberInfo.avatar ? memberInfo.avatar :  -->
                        <van-image :src="require('@/assets/images/user/user_avatar_default.png')" width="60" height="60" round fit="cover" style="margin-right: 10px;"></van-image>
                    </template>
                    <template #title>
                        <div style="color:#fff">{{memberInfo.nickName}}</div>
                    </template>
                    <template #label>
                        <div style="color: #c0c4cc">{{memberInfo.mobile | hideMobile}}</div>
                    </template>
                    <!-- <div style="color: #fff" @click="beforeLogout">退出登录</div> -->
                </van-cell>
                <van-cell v-else center style="background-color: transparent" @click="$goPage('login')">
                    <template #icon>
                        <van-image :src="require('@/assets/images/user/user_avatar_offline.png')" width="60" height="60" round fit="cover" style="margin-right: 10px;"></van-image>
                    </template>
                    <!-- <template #title>
                        <div style="color: #fff" @click="$goPage('login')">立即登录</div>
                    </template> -->
                </van-cell>
            </div>
            <div class="user_order-wrap">
                <div class="user_order">
                    <van-cell value="全部" is-link @click="toUserOrder(0)">
                        <template #title>
                            <div class="user_func-title">我的订单</div>
                        </template>
                    </van-cell>
                    <div class="user_order-tab fx-row fx-around">
                        <div class="fx-center" @click="toUserOrder(1)">
                            <van-icon :name="require('@/assets/images/user/user_dfk.png')" size="25"></van-icon>
                            <span>待付款</span>
                        </div>
                        <div class="fx-center" @click="toUserOrder(2)">
                            <van-icon :name="require('@/assets/images/user/user_yfk.png')" size="25"></van-icon>
                            <span>已付款</span>
                        </div>
                        <div class="fx-center" @click="toUserOrder(3)">
                            <van-icon :name="require('@/assets/images/user/user_tk.png')" size="25"></van-icon>
                            <span>退 款</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="body-wrap fx-fill">
            <div class="fill-box">
                <div class="user_func-wrap">
                    <div class="user_func-title">卡券中心</div>
                    <div class="user_coupon-list fx-row fx-between">
                        <div class="user_coupon-item fx-row fx-center-middle" @click="toCoupon">
                            <van-icon :name="require('@/assets/images/user/user_card-icon1.png')" size="3em"></van-icon>
                            <div class="user_coupon-desc">
                                <div>优惠券/兑换券</div>
                                <div v-if="authCode" class="fc-primary">({{couponTotal}})/({{exchangeCardTotal}})</div>
                            </div>
                        </div>
                        <div class="user_coupon-item fx-row fx-center-middle" @click="toVip">
                            <van-icon :name="require('@/assets/images/user/user_card-icon2.png')" size="3em"></van-icon>
                            <div class="user_coupon-desc">
                                <div>贵宾卡</div>
                                <div v-if="authCode" class="fc-primary">{{vipTotal | formatIntToMoney}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="user_func-wrap" @click="redirect">
                    <div class="user_func-title">更多服务</div>
                    <div class="user_more fx-middle"></div>
                    <!-- <div class="fc-tips user_provider fx-center">由喜车提供技术服务</div> -->
                </div>
            </div>
        </div>
        <!-- <div class="footer-wrap">
            <tab-bar></tab-bar>
        </div> -->
    </div>
</template>

<script>
import TabBar from "@/components/tab-bar";
import { mapActions, mapGetters } from 'vuex';
export default {
    data() {
        return {
            couponTotal: 0,
            exchangeCardTotal: 0,
            vipTotal: 0,
        }
    },
    computed: {
        ...mapGetters([
            'hasGetMemberInfo',
            'authCode'
        ]),
        memberInfo() {
            return this.$store.state.user.memberInfo;
        },
    },
    methods: {
        ...mapActions([
            'logout'
        ]),
        getMemberCouponList(type) {
            return new Promise((resolve) => {
                let params = {
                    type,
                }
                this.$service.getMemberCouponList(params).then((res) => {
                    resolve(res.pagination.item_total);
                })
            });
        },
        getVipList() {
            let params = {
                type: 'VIP',
            }
            this.$service.getMemberVipList(params).then((res) => {
                let couponList = res.couponlist;
                if (couponList && couponList.length > 0) {
                    this.vipTotal = couponList[0].balance;
                }
            });
        },
        toCoupon() {
            if (this.validIsLogin()) {
                this.$goPage('user-coupon')
            }
        },
        toVip() {
            if (this.validIsLogin()) {
                this.$goPage('user-vip');
            }
        },
        toUserOrder(index) {
            if (this.validIsLogin()) {
                this.$goPage('user-order', index ? { index } : '');
            }
        },
        beforeLogout() {
            this.$dialog.confirm({
                title: '系统提示',
                message: '确认退出登录吗?'
            }).then(() => {
                this.logout();
            });
        },
        validIsLogin(toast = true) {
            if (!this.authCode) {
                if (toast) {
                    this.$toast('您还未登录');
                }
                return false;
            }
            return true;
        },
        redirect() {
            // if (this.validIsLogin()) {
            //     window.location.href = `https://wx.dumovie.com/app/order/movie/list?auth_code=${this.authCode}&app_source=h5`;
            // }
        },
        initPage() {
            if (this.validIsLogin(false)) {
                this.getVipList();
                Promise.all([this.getMemberCouponList('A'), this.getMemberCouponList('D')]).then((res) => {
                    this.couponTotal = res[0];
                    this.exchangeCardTotal = res[1];
                });
            }
        }
    },
    mounted() {
        this.initPage();
    },
    components: {
        TabBar
    }
}
</script>

<style lang="scss" scoped>
/deep/ .user_func-title {
	font-size: 15px;
	font-weight: 900;
}
.header-wrap {
	position: relative;
	z-index: 0;
	background: url(../../assets/images/user/user_avatar_bg.png) no-repeat;
	.user_info-wrap {
		color: #fff;
		.user_info {
			padding: 10px 18px;
			.user_name {
				padding: 0 10px;
				font-size: 16px;
			}
		}
	}
	.user_order-wrap {
		padding: 0 16px;
		.user_order {
			border-radius: 6px;
			background-color: #fff;
			overflow: hidden;
			box-shadow: 0px 2px 3px #bb96c1;
			.user_order-tab {
				padding: 15px 0;
				> div {
					> span {
						margin-top: 4px;
					}
				}
			}
		}
	}
}

.body-wrap {
	position: relative;
	.user_func-wrap {
		margin-top: 20px;
		padding: 0 16px;
		.user_func-title {
			margin-bottom: 8px;
		}
		.user_coupon-list {
			.user_coupon-item {
				box-shadow: 0px 2px 3px #bb96c1;
				background-color: #fff;
				border-radius: 6px;
				width: 48%;
				padding: 15px 0;
				> * {
					padding: 0 8px;
				}
				.user_coupon-desc {
					> div {
						line-height: 1.8;
					}
				}
			}
		}
		.user_more {
			background: url("../../assets/images/user/user_more.png") no-repeat;
			padding-left: 28px;
			color: #fff;
			background-size: 100% 100%;
			height: 100px;
		}
		.user_provider {
			font-size: 12px;
			/* 利用放大缩小属性 */
			-webkit-transform: scale(0.83);
		}
	}
}
</style>
